import { getLabelsByLanguage } from "../../../../../utilites/util";
import Spinner from "../../../../components/spinner/Spinner";

const LoadingIndicator = () => {
  const labels = getLabelsByLanguage();

  return (
    <div className="text-center pt-4">
      <Spinner loadingLabel={labels.xnpLoadingIndicator} isOverlay={true} />
    </div>
  );
};

export default LoadingIndicator;
